var Mn = require('backbone.marionette');

module.exports = Mn.Behavior.extend({
    ui: {
        'form': '[data-newsletter]',
        'message': '[data-form-message]'
    },
    events: {
        'submit @ui.form': 'submit'
    },
    submit: function(event) {
        var self = this;
        var form = this.ui.form
        var url = form.attr( 'action' ),
            data = form.serialize(),
            message = this.ui.message;

        message.text( 'Enviando...' )
            .removeClass( 'success error' )
            .show();

        $.post( url, data )
            .done( function( response ) {
                console.log(response);
                message.text( 'Enviado com sucesso' ).addClass( 'success' );
            })
            .fail( function( error ) {
                console.log(error);
                message.text( 'Ocorreu um erro.' ).addClass( 'error' );
            })
            .always( function( response ) {
                window.setTimeout( function() {
                    self.ui.form.find('input[type=text], input[type=email], textarea').val('');
                    message.text( '' ).hide();
                }, 8000 );
            });

        return false;
    }
});



//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/scripts/behaviors/Newsletter.js
// module id = 229
// module chunks = 3